export const getDay = (dateStart, dateEnd) => {
  const parseStartDate = Date.parse(dateStart);
  const parseEndDate = Date.parse(dateEnd);
  const totalDays = Math.floor(
    (parseEndDate - parseStartDate + 86400000) / 86400000
  );
  return totalDays + ' Days';
};
